import React, { Suspense, lazy } from 'react'
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom'
import { ProtectedElement } from '@praxis/component-auth'
import PcnView from '../views/PcnView'
import { ExternalNavRoutes, NavBar } from 'components/NavBar'

const HomeContainer = lazy(() => import('../views/Vendor/Home'))
const EventsContainer = lazy(() => import('../views/Vendor/Events'))
const ItemSetupContainer = lazy(() => import('../views/Vendor/ItemSetup'))
const VendorEventContainer = lazy(() => import('../views/Vendor/VendorEvent'))

export const externalAppRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <Suspense
          fallback={<div>Please wait while your page is loading...</div>}
        >
          <NavBar navRoutes={ExternalNavRoutes} />
          <ProtectedElement />
        </Suspense>
      }
    >
      <Route path="*" />
      <Route
        path="/"
        element={
          <PcnView view="home">
            {viewProps => {
              return <HomeContainer {...viewProps} />
            }}
          </PcnView>
        }
      />
      <Route
        path="/events"
        element={
          <PcnView view="events">
            {viewProps => {
              return <EventsContainer {...viewProps} />
            }}
          </PcnView>
        }
      />
      <Route
        path="/item-setup"
        element={
          <PcnView view="item-setup">
            {viewProps => {
              return <ItemSetupContainer {...viewProps} />
            }}
          </PcnView>
        }
      />
      <Route
        path="/:id/vendor-bids"
        element={
          <PcnView view="vendor-bids">
            {viewProps => {
              return <VendorEventContainer {...viewProps} />
            }}
          </PcnView>
        }
      />
      <Route
        path="/:id/costing-bids"
        element={
          <PcnView view="vendor-costing-bids">
            {viewProps => {
              return <VendorEventContainer {...viewProps} />
            }}
          </PcnView>
        }
      />
      <Route
        path="/:id/manage-files"
        element={
          <PcnView view="manage-files">
            {viewProps => {
              return <VendorEventContainer {...viewProps} />
            }}
          </PcnView>
        }
      />
      <Route
        path="/:id/vendor-alignment"
        element={
          <PcnView view="vendor-alignment">
            {viewProps => {
              return <VendorEventContainer {...viewProps} />
            }}
          </PcnView>
        }
      />
    </Route>,
  ),
)
